module.exports = __webpack_public_path__ + "assets/img/img-training-02.65234a94.jpg";